var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureTileIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#D7DDDD;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2_00000098197705911788952850000017416751865890436489_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.01,
    y: 19.12,
    className: "st2",
    width: 27.96,
    height: 27.96
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.68,32.95c0,6.25,5.07,11.32,11.32,11.32s11.32-5.07,11.32-11.32S38.25,21.63,32,21.63 S20.68,26.7,20.68,32.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.05,29.66l-5.48,7.31c-0.47,0.63-1.36,0.75-1.98,0.28c-0.05-0.04-0.1-0.08-0.15-0.13l-2.83-2.83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon04);
export default __webpack_public_path__ + "static/media/feature-tile-icon-04.9ed1efedbd12b6d94c5f06eb4bb321f8.svg";
export { ForwardRef as ReactComponent };